"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Files = void 0;
class Files {
    static SaveToDownloads(name, mime, url) {
        var ref = global.window.open(url, '_blank');
        if (ref) {
            return Promise.resolve(null);
        }
        else {
            // Workaround for Safari to allow the popup.
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    ref = global.window.open(url, '_blank');
                    if (ref) {
                        resolve(null);
                    }
                    else {
                        reject(null);
                    }
                });
            });
        }
    }
    static async SaveToDownloadsWithResult(name, mime, url, headers = {}, onProgress) {
        const hasHeaders = headers && Object.keys(headers).length > 0;
        if (!hasHeaders) {
            await Files.SaveToDownloads(name, mime, url);
            return { path: "" };
        }
        onProgress?.(0, 1);
        const res = await fetch(url, { method: "GET", headers });
        if (!res.ok)
            throw new Error(`Download failed: ${res.status}`);
        const blob = await res.blob();
        const href = window.URL.createObjectURL(new Blob([blob], { type: mime }));
        const a = document.createElement("a");
        a.href = href;
        a.download = name;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(href);
        onProgress?.(1, 1);
        return { path: "" };
    }
}
exports.Files = Files;
